import { useState, type FormEvent } from "react";
import { useAuth } from "./auth";

export function Login() {
  const { login } = useAuth();
  const [token, setToken] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    if (!token.trim()) return;
    setBusy(true);
    setError(null);
    try {
      await login(token.trim());
    } catch {
      setError("Nieprawidłowy token.");
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login__card" onSubmit={onSubmit}>
        <h1 className="login__title">GTD</h1>
        <p className="login__hint">Podaj token dostępu.</p>

        <input
          className="login__input"
          type="password"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          placeholder="Token"
          autoComplete="current-password"
          autoFocus
          aria-label="Token dostępu"
        />

        {error && (
          <p className="login__error" role="alert">
            {error}
          </p>
        )}

        <button className="login__button" type="submit" disabled={busy || !token.trim()}>
          {busy ? "Sprawdzam..." : "Zaloguj"}
        </button>

        <p className="login__hint">
          <a href="/prywatnosc">Zasady prywatności</a>
        </p>
      </form>
    </div>
  );
}
